/**
 * Styled components for ResetChatButton
 */

import styled from 'styled-components';

import { IOcAppTheme, OcColors } from '../../config/ocTheme';
import { disabledBehavior } from '../Shared/ButtonDisabledBehavior.styled';
import { overlayInteraction } from '../Shared/ButtonOverlay.styled';

export const ResetButton = styled.button`
  display: inline-flex;
  align-items: center;
  border: none;
  gap: 4px;
  padding: 8px 12px;
  border-radius: 4px;

  background: transparent;
  color: ${({ theme }) => (theme as IOcAppTheme).color.textPrimary || OcColors.defaultText};
  font-size: ${({ theme }) => theme.font.size.small};
  font-weight: ${({ theme }) => theme.font.weight.semiBold};

  ${disabledBehavior()}
  ${overlayInteraction({isHighlighted: (theme) => !!(theme as IOcAppTheme).color.highlightOnChatBG})}

  &.clear-chat-button svg {
    color: ${({ theme }) => (theme as IOcAppTheme).color.textPrimary || OcColors.defaultText};
  }

  /* Special styling for new-chat-button in chat history */
  &.new-chat-button {
    width: 100%;
    display: flex;
    justify-content: center;
    
    padding: 4px 16px;
    font-size: ${({ theme }) => theme.font.size.default};
    font-weight: ${({ theme }) => theme.font.weight.regular};
    background-color: ${({ theme }) => (theme as IOcAppTheme).color.buttonBG || theme.color.chatPanelBG};
    border: none;
    color: ${({ theme }) => (theme as IOcAppTheme).color.buttonText || theme.color.chatPanel};

    ${overlayInteraction({
      isHighlighted: (theme) => (theme as IOcAppTheme).color.buttonBG 
        ? !!(theme as IOcAppTheme).color.highlightOnButtonBG 
        : !!(theme as IOcAppTheme).color.highlightOnChatPanelBG, 
      backgroundColor: (theme) => (theme as IOcAppTheme).color.buttonBG || theme.color.chatPanelBG })}
  }
`;
